export const HOME_PAGE = '/';
export const LOGIN_PAGE = '/login';
export const BASE_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:3001'
  : 'https://podsight.bitcap.team';

export const GOOGLE_CLIENT_ID = '629233254982-6c21u3c2rtfoupq6g3fi7dsrknec1pfj.apps.googleusercontent.com';
export const GOOGLE_BACKEND = 'google-oauth2';
export const APP_ID = 'kP3p35uOTaeXsWjnI48pz1HFbjJHIGUlPPLRvOKm';
export const APP_SECRET = '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';